import React from 'react';
export function Footer() {
  return <footer className="bg-dark-800 py-12 border-t border-dark-800/50" data-id="element-58">
      <div className="container mx-auto px-6 text-center" data-id="element-59">
        <p className="text-gray-500 text-sm mb-4" data-id="element-60">
          © {new Date().getFullYear()} Recetas Caseras para Mascotas. Todos los
          derechos reservados.
        </p>
        <div className="flex justify-center gap-6 text-sm text-gray-600" data-id="element-61">
          <a href="#" className="hover:text-earth-amber transition-colors" data-id="element-62">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-earth-amber transition-colors" data-id="element-63">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-earth-amber transition-colors" data-id="element-64">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}